import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { isSP } from "../../common/functions/isSP.es6";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class MainScroll {
  constructor() {
    this.init();
  }

  init() {
    this.setScroll();
  }

  setScroll() {
    const stillPrrx = [...document.querySelectorAll(".js-stillprrx")];

    stillPrrx.forEach((el) => {
      if (el.getAttribute("data-nrwnoprrx") && isSP()) {
        return;
      }

      gsap.to(el, {
        scrollTrigger: {
          trigger: el,
          scrub: 1,
        },
        y: `-10%`,
      });
    });
  }
}
